// fallow-ignore-next-line boundary-violation -- shared sales helper lives in workspace zone; move pending
import { createCancelable } from "app/pages/workspace/sales/helpers";
import type { IFetchService } from "app/services/fetchService";
import type { IntegrationStatusResponse } from "../../../components/types";
import type { CRMListObjectsType } from "../../../types";

export type DynamicsTogglesServiceType = {
    getDynamicsExclusionStatus(): Promise<{ value: boolean }>;
    getDynamicsAccountsExportStatus(): Promise<{ value: boolean }>;
    putDynamicsExcludeStatus(state: boolean): Promise<IntegrationStatusResponse>;
    putDynamicsContactsFilterStatus(state: boolean): Promise<IntegrationStatusResponse>;
    putDynamicsAccountsFilterStatus(state: boolean): Promise<IntegrationStatusResponse>;
    putDynamicsLeadsToggle(state: boolean): Promise<IntegrationStatusResponse>;
    putDynamicsCompanyAsLeadsToggle(state: boolean): Promise<IntegrationStatusResponse>;
    setIsDynamicsCrmLabelEnabled(state: boolean): Promise<IntegrationStatusResponse>;
    setIsDynamicsCrmListEnabled(state: boolean): Promise<IntegrationStatusResponse>;
    setDynamicsCrmListObjectsType(state: CRMListObjectsType): Promise<IntegrationStatusResponse>;
};

export const dynamicsTogglesService = (fetchService: IFetchService): DynamicsTogglesServiceType => ({
    getDynamicsExclusionStatus: createCancelable((signal: AbortSignal): Promise<{ value: boolean }> => {
        return fetchService
            .get<{ value: boolean } | null>(`sales-api/microsoft-dynamics/leads-filter-toggle`, undefined, {
                cancellation: signal,
            })
            .then((res) => ({ value: res?.value ?? false }));
    }),
    getDynamicsAccountsExportStatus: createCancelable((signal: AbortSignal): Promise<{ value: boolean }> => {
        return fetchService.get("sales-api/microsoft-dynamics/export-toggle", undefined, {
            cancellation: signal,
        });
    }),
    putDynamicsExcludeStatus: createCancelable(
        (signal: AbortSignal, state: boolean): Promise<IntegrationStatusResponse> => {
            return fetchService.put(`sales-api/microsoft-dynamics/leads-filter-toggle?value=${state}`, undefined, {
                cancellation: signal,
            });
        },
    ),
    putDynamicsContactsFilterStatus: createCancelable(
        (signal: AbortSignal, state: boolean): Promise<IntegrationStatusResponse> => {
            return fetchService.put(`sales-api/microsoft-dynamics/contact-export-toggle?value=${state}`, undefined, {
                cancellation: signal,
            });
        },
    ),
    putDynamicsAccountsFilterStatus: createCancelable(
        (signal: AbortSignal, state: boolean): Promise<IntegrationStatusResponse> => {
            return fetchService.put(`sales-api/microsoft-dynamics/export-toggle?value=${state}`, undefined, {
                cancellation: signal,
            });
        },
    ),
    putDynamicsLeadsToggle: createCancelable(
        (signal: AbortSignal, state: boolean): Promise<IntegrationStatusResponse> => {
            return fetchService.put(`sales-api/microsoft-dynamics/leads-export-toggle?value=${state}`, undefined, {
                cancellation: signal,
            });
        },
    ),
    putDynamicsCompanyAsLeadsToggle: createCancelable(
        (signal: AbortSignal, state: boolean): Promise<IntegrationStatusResponse> => {
            return fetchService.put(
                `sales-api/microsoft-dynamics/company-as-lead-export-toggle?value=${state}`,
                undefined,
                { cancellation: signal },
            );
        },
    ),
    setIsDynamicsCrmLabelEnabled: createCancelable(
        (signal: AbortSignal, state: boolean): Promise<IntegrationStatusResponse> => {
            return fetchService.put(`/sales-api/microsoft-dynamics/crm-labels-toggle?value=${state}`, undefined, {
                cancellation: signal,
            });
        },
    ),
    setIsDynamicsCrmListEnabled: createCancelable(
        (signal: AbortSignal, state: boolean): Promise<IntegrationStatusResponse> => {
            return fetchService.put(`/sales-api/microsoft-dynamics/crm-list-toggle?value=${state}`, undefined, {
                cancellation: signal,
            });
        },
    ),
    setDynamicsCrmListObjectsType: createCancelable(
        (signal: AbortSignal, value: CRMListObjectsType): Promise<IntegrationStatusResponse> => {
            return fetchService.put(`/sales-api/microsoft-dynamics/crm-list/monitor-types?value=${value}`, undefined, {
                cancellation: signal,
            });
        },
    ),
});
